import React from 'react';
import './Contact.css';

export default function Contact() {
    return (
        <p>
            <b>Dr Irene C. Dedoussi</b>
            <br />
            <br />
            <b>Office: </b>{' '}
            <a href="https://map.cam.ac.uk/?maplon=0.09281&maplat=52.21205&mapzoom=19&maplayers=Building+Labels%2CExternal+Sites%2CColleges%2CUniversity+Sites%2CBuildings%2CCar+Parks%2CTransport&mapfeature=mfid19%2CBuildings">
                Whittle Laboratory
            </a>
            , Office 106
            <br />
            <br />
            <b>Telephone: </b>
            +44 (0)1223 746973
            <br />
            <br />
            <b>Address:</b>
            <br />
            1 JJ Thomson Avenue,
            <br />
            Cambridge, CB3 0DY
            <br />
            United Kingdom
            <br />
            <br />
            <b>
                Email: <a href="mailto: icd23@cam.ac.uk">icd23@cam.ac.uk</a>
            </b>
        </p>
    );
}
